import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import {
  setInLocal,
  getParamFromQueryString,
  getValidCoupon,
} from "../../utils/app-helpers";
import Banners from "../partials/banners";
import BookCallout from "../partials/book-callout";
import CouponReminder from "../partials/coupon-reminder";
import CovidCallout from "../partials/covid-callout";
import DestinationCallout from "../partials/destination-callout";
import FaqCallout from "../partials/faq-callout";
import HelmetWrapper from "../partials/helmet-wrapper";
import ImageSlider from "../partials/image-slider";
import Itinerary from "../partials/itinerary";
import Lineup from "../partials/lineup";
import NewsletterCallout from "../partials/newsletter-callout";
import ReviewsCallout from "../partials/reviews-callout";
import SiteFooter from "../partials/site-footer";
import SiteHeader from "../partials/site-header";
import SoldOutBar from "../partials/sold-out-bar";
import ThinBar from "../partials/thin-bar";
import TripHeader from "../partials/trip-header";
import PhotosCallout from "../partials/photos-callout";
import VideoRow from "../partials/video-row";
import VimeoPlayer from "../partials/vimeo-player";

const { siteMetadata: config } = GatsbyConfig;

export default class TripPage extends React.Component {
  state = { cachedCoupon: null };

  componentDidMount() {
    const { trip } = this.props;
    const tripData = config.trips[trip];
    let cachedCoupon = {};

    setInLocal("lsg.last-viewed-trip", trip);

    if (!this.state.cachedCoupon && typeof window !== "undefined") {
      const qString = window.location.href;
      const coupon = getParamFromQueryString("c", qString).toUpperCase();
      const matchedTrip = config.trips[trip];

      if (matchedTrip && matchedTrip.useCoupons) {
        const matchedCoupon = getValidCoupon(coupon, matchedTrip.coupons);

        if (matchedCoupon) {
          setInLocal(`lsg.coupon.${trip}`, JSON.stringify(matchedCoupon));
          cachedCoupon = matchedCoupon;
        }
      }
    }
    this.setState({ cachedCoupon });
  }

  render() {
    const { trip, metaTitle, metaDescription } = this.props;
    const { cachedCoupon, showModal } = this.state;
    if (!trip) return <main />;
    const tripData = config.trips[trip];

    return (
      <div className={`page-trip trip-${trip}`}>
        <HelmetWrapper
          metaTitle={metaTitle}
          metaDescription={metaDescription}
        />
        <div className="bookmark" id="top" />
        <SiteHeader trip={trip} />
        <TripHeader trip={trip} />
        {cachedCoupon && <CouponReminder trip={trip} />}
        <main>
          <ImageSlider
            trip={trip}
            waitForImage={`/images/trip-slider-${trip}-wow.jpg`}
            slides={[
              `
              <div
                class="slide slide-${trip}-wow active"
                style="
                  background-image: url('/images/trip-slider-${trip}-wow.jpg')
                "
              >
                ${
                  trip === "kauai2021"
                    ? `
                        <div class="wrap">
                          <img
                            class="logo-${tripData.venueSlug}"
                            src="/images/logos/${tripData.venueSlug}.png"
                            alt="${tripData.venue}"
                          />
                          <img
                            class="logo-anniversary-kauai2021"
                            src="/images/logos/anniversary-kauai2021.jpg"
                            alt="20th Anniversary"
                          />
                        </div>
                      `
                    : ""
                }
                ${
                  trip === "cancun2020" || trip === "cancun2021"
                    ? `
                        <div class="wrap">
                          <img
                            class="logo-anniversary-cancun2020"
                            src="/images/logos/anniversary-cancun2020.png"
                            alt="10th Annual Getaway"
                          />
                        </div>
                      `
                    : ""
                }
                ${
                  trip === "maui2021"
                    ? `
                        <div class="wrap">
                          <img
                            class="logo-${tripData.venueSlug}"
                            src="/images/logos/${tripData.venueSlug}.png"
                            alt="${tripData.venue}"
                          />
                        </div>
                      `
                    : ""
                }
              </div>
            `,
              `
                <div
                  class="slide slide-${trip}-venu"
                  style="
                    background-image: url('/images/trip-slider-${trip}-venue.jpg')
                  "
                >
                  ${
                    trip !== "kauai2021" && trip !== "maui2021"
                      ? `
                        <div class="wrap">
                          <img
                            class="logo-${tripData.venueSlug}"
                            src="/images/logos/${tripData.venueSlug}.png"
                            alt="${tripData.venue}"
                          />
                        </div>
                      `
                      : ""
                  }
                </div>
              `,
              `
              <div
                class="slide slide-${trip}-couple"
                style="
                  background-image: url('/images/trip-slider-${trip}-couple.jpg')
                "
              >
                ${
                  trip === "maui2021"
                    ? `
                        <div class="wrap">
                          <img
                            class="logo-${tripData.venueSlug}"
                            src="/images/logos/${tripData.venueSlug}.png"
                            alt="${tripData.venue}"
                          />
                        </div>
                      `
                    : ""
                }
              </div>`,
            ]}
          />
          <Banners trip={trip} />
          {tripData.thinBar1 ? <ThinBar message={tripData.thinBar1} /> : ""}
          <div className="wrap">
            <Lineup trip={trip} location={this.props.location} />
          </div>
          <SoldOutBar trip={trip} />
          <div className="bookmark" id="video" />
          <VideoRow>
            <VimeoPlayer videoId={tripData.homeVideoId} />
          </VideoRow>
          <DestinationCallout trip={trip} />
          <SoldOutBar trip={trip} />
          <NewsletterCallout
            trip={trip}
            requireFirstName={tripData.requireFirstNameForNewsletter}
            requireLastName={tripData.requireLastNameForNewsletter}
            analyticsLocation="overview"
          />
          <PhotosCallout trip={trip} />
          <BookCallout trip={trip} />
          <div className="bookmark" id="stay-informed" />
          <Itinerary trip={trip} />
          <FaqCallout trip={trip} />
          <ReviewsCallout trip={trip} />
          <CovidCallout trip={trip} />
          <div
            style={{
              backgroundImage: `url(/images/trip-footer-${trip}-splash.jpg)`,
            }}
            className={`image footer-${trip} mobile-100x50 desktop-300`}
          />
          <div className="quote">
            <div className="wrap">
              <p>
                <q>
                  Come aside by yourselves to a <br />
                  deserted place and rest awhile
                </q>
                <cite>Mark 6:31</cite>
              </p>
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/trip.js